import { useEffect } from "react";
import { Button, Modal, Form, message, Row, Col, Input } from "antd";
import Moment from "react-moment";
import postDataTrace from "../../../../services/postDataTrace";

export default function UpdateCode({
  isVisible,
  selected,
  setVisible,
  handleFetchBookings,
}: any) {
  const [form] = Form.useForm();

  const onSubmit = async () => {
    let { promo_code } = form.getFieldsValue();
    const data = { promo_code };
    const booking_id = selected._id;
    const uri = `bookings/${booking_id}/update/promo_code`;
    const response = await postDataTrace(data, uri);
    if (response.success) {
      message.success("Updated successfully");
    } else {
      message.error("Something went wrong");
    }
    setVisible(false);
    await handleFetchBookings();
  };

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Promo Code"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdatePromoCode"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Add Promo Code
        </Button>,
      ]}
    >
      <Form
        id="UpdatePromoCode"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
          </div>
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="promo_code"
              label="Promo Code"
              rules={[
                {
                  required: true,
                  message: "Please enter Promo Code",
                },
              ]}
            >
              <Input placeholder="Promo Code" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
